// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"187":"84294564","213":"62df3f73","239":"b7ad4f0d"}[chunkId] + ".chunk.js";
};